import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Table,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Backdrop,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TableBody,
  Tooltip,
} from "@mui/material";
import FileUploadMulti from "../../../documenti/FileUploadMulti";
import { useState, useEffect } from "react";
import { Delete, CloudUpload, Download } from "@mui/icons-material";
import { API_BASE_URL } from "../../../../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../redux/slices/snackbar";
import { useFormRCAutoDetails } from "../../rcautoContext";

const Documenti = ({ idUidRequest }) => {
  const { formState, dispatch: dispatchForm } = useFormRCAutoDetails();
  const [loadingPage, setLoadingPage] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(formState);

  const fetchDocuments = async () => {
    const token = sessionStorage.getItem("token");
    setLoadingPage(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/requestGetDocument`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUIDRequest: idUidRequest,
        }),
      });
      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }
      if (responseData.status === 0) {
        navigate("/private");
        handleSnackbar(responseData.message, "error");
        return;
      }

      if (responseData.status === 1) {
        const docs = Array.isArray(responseData.data)
          ? responseData.data
          : responseData.data?.documenti || [];

        dispatchForm({
          type: "DOCUMENTI",
          payload: {
            documenti: docs,
          },
        });
      }
      setLoadingPage(false);
    } catch (error) {
      console.error("Errore nel recupero documenti:", error);
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const selectOptions = (formState.documenti || []).filter(
    (el) => el.tOb === 2,
  );

  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  const handleRowFileUpload = (item, files) => {
    const uploadedFile = files[0];
    handleSave(item, uploadedFile);
  };

  const AddRow = async (idUidDocumento) => {
    if (!idUidDocumento) {
      handleSnackbar("Seleziona un documento dalla lista", "warning");
      return;
    }
    const documento = selectOptions.find(
      (el) => el.idUidDocumento === idUidDocumento,
    );
    if (!documento) return;
    if (
      (formState.documenti || []).some(
        (r) => r.idUidDocumento === idUidDocumento && r.tOb === 1,
      )
    ) {
      handleSnackbar("Documento già presente in tabella", "info");
      return;
    }
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      // Uncomment to enable API call
      const response = await fetch(`${API_BASE_URL}/api/requestAddDocument`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUidDocumento: idUidDocumento,
          idUIDRequest: idUidRequest,
        }),
      });

      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        setSelectValue("");
        fetchDocuments();
      }
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il salvataggio.", "error");
    } finally {
      setLoadingPage(false);
    }
  };

  const handleSave = async (item, uploadedFile) => {
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", uploadedFile);
    formData.append("idUidDoc", item.idUidDocumento);
    formData.append("idUidRequest", idUidRequest);

    try {
      // Uncomment to enable API call
      const response = await fetch(`${API_BASE_URL}/api/requestUploadFile`, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
        },
        body: formData,
      });

      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        fetchDocuments();
      }
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il salvataggio.", "error");
    } finally {
      setLoadingPage(false);
    }
  };

  async function handleDownloadFile(el) {
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      const res = await fetch(`${API_BASE_URL}/api/requestDownloadFile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUidDoc: el.idUidDocumento,
          idUidRequest: idUidRequest,
        }),
      });

      // Controlla se la risposta è JSON (errore) o un file (octet-stream)
      const contentType = res.headers.get("Content-Type");

      if (contentType && contentType.includes("application/json")) {
        // È un errore JSON, quindi leggi il JSON
        const response = await res.json();
        if (response.status === 0) {
          handleSnackbar(response.message, "error");
        } else {
          handleSnackbar("Errore sconosciuto", "error");
        }
      } else {
        // È un file da scaricare
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // Prendi il nome file originale dall'header X-Filename, se esiste
        const originalFilename =
          res.headers.get("X-Filename") || el.idUidDocumento;

        const a = document.createElement("a");
        a.href = url;
        a.download = originalFilename; // usa il nome originale se disponibile
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        handleSnackbar("File scaricato con successo", "success");
      }
    } catch (error) {
      handleSnackbar("Download Fallito", "error");
    } finally {
      setLoadingPage(false);
    }
  }

  async function handleDelete(el) {
    setItemToDelete(el);
    setOpenDeleteDialog(true);
  }

  async function confirmDelete() {
    if (!itemToDelete) return;
    setOpenDeleteDialog(false);
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      // Endpoint placeholder as requested
      const res = await fetch(`${API_BASE_URL}/api/requestDeleteDocument`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUidDoc: itemToDelete.idUidDocumento,
          idUidRequest: idUidRequest,
        }),
      });

      const responseData = await res.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }

      if (responseData.status === 1) {
        handleSnackbar(
          responseData.message || "Documento eliminato",
          "success",
        );
        fetchDocuments();
      } else {
        handleSnackbar(responseData.message || "Errore eliminazione", "error");
      }
    } catch (error) {
      handleSnackbar("Errore durante l'eliminazione", "error");
    } finally {
      setItemToDelete(null);
      setLoadingPage(false);
    }
  }

  return (
    <Box display="flex" flexDirection="column" gap={4} width="100%">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingPage}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        display="flex"
        justifyContent="space-between"
        gap={4}
        width="100%"
        alignItems="center"
      >
        <FormControl size="small" margin="none" fullWidth>
          <InputLabel id="tipologia-label">Tipologia</InputLabel>
          <Select
            labelId="tipologia-label"
            id="tipologia"
            name="tipologia"
            label="Tipologia"
            value={selectValue}
            onChange={(e) => setSelectValue(e.target.value)}
            disabled={!selectOptions.length}
          >
            {selectOptions.map((el) => (
              <MenuItem key={el.idUidDocumento} value={el.idUidDocumento}>
                {el.nome}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={() => AddRow(selectValue)}
          variant="contained"
          disabled={!selectOptions.length}
        >
          Aggiungi
        </Button>
      </Box>
      <Box
        sx={{
          maxHeight: 400,
          overflowY: "auto",
          width: "100%",
          border: "1px solid #929292ff",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Documento</TableCell>
              <TableCell align="left">Azioni</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(formState.documenti || [])
              .filter((doc) => doc.tOb === 1)
              .map((el) => (
                <TableRow key={el.idUidDocumento}>
                  <TableCell sx={{ height: "30px" }}>
                    <Box
                      sx={{
                        fontWeight: "bold",
                        color:
                          el.dataCaricamento !== ""
                            ? "success.main"
                            : "inherit",
                      }}
                    >
                      {el.nome}
                    </Box>
                    {el.dataCaricamento && (
                      <Box sx={{ fontSize: "11px", mt: 0.5 }}>
                        {el.dataCaricamento}
                      </Box>
                    )}
                  </TableCell>
                  <TableCell>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      justifyContent="flex-start"
                    >
                      <FileUploadMulti
                        onFileAccepted={(files) =>
                          handleRowFileUpload(el, files)
                        }
                        trigger={({ open }) => (
                          <Tooltip title="Upload">
                            <IconButton
                              color="primary"
                              onClick={open}
                              disabled={el.idTipo === 3}
                            >
                              <CloudUpload />
                            </IconButton>
                          </Tooltip>
                        )}
                      />
                      {el.dataCaricamento !== "" && (
                        <Tooltip title="Download">
                          <IconButton
                            color="secondary"
                            onClick={() => handleDownloadFile(el)}
                          >
                            <Download sx={{ fontSize: 20 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      {el.toO === 2 && (
                        <Tooltip title="Elimina">
                          <IconButton
                            color="secondary"
                            onClick={() => handleDelete(el)}
                          >
                            <Delete size={20} sx={{ color: "red" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sei sicuro di voler eliminare il documento "{itemToDelete?.nome}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>No</Button>
          <Button onClick={confirmDelete} color="error" autoFocus>
            Sì, elimina
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Documenti;
